import type { Lang } from "./i18n";

/** Names and symbols belong to the common language domain, never to a product menu. */
export const languageCatalog = {
  de: { symbol: "🇩🇪", names: { de: "Deutsch", en: "German", ru: "Немецкий", uk: "Німецька", it: "Tedesco" } },
  en: { symbol: "🇬🇧", names: { de: "Englisch", en: "English", ru: "Английский", uk: "Англійська", it: "Inglese" } },
  ru: { symbol: "🇷🇺", names: { de: "Russisch", en: "Russian", ru: "Русский", uk: "Російська", it: "Russo" } },
  uk: { symbol: "🇺🇦", names: { de: "Ukrainisch", en: "Ukrainian", ru: "Украинский", uk: "Українська", it: "Ucraino" } },
  it: { symbol: "🇮🇹", names: { de: "Italienisch", en: "Italian", ru: "Итальянский", uk: "Італійська", it: "Italiano" } },
} satisfies Record<Lang, { symbol: string; names: Record<Lang, string> }>;

/** Languages with complete UI translations in the current AppShell consumers. */
export const appShellLanguages = ["de", "en"] as const satisfies readonly Lang[];
export type AppShellLanguage = typeof appShellLanguages[number];
export const languageMenuLabels = { de: "Sprache", en: "Language", ru: "Язык", uk: "Мова", it: "Lingua" } satisfies Record<Lang, string>;
